import { Button } from '@curology/ui-components-web/react/Button';
import { Modal } from '@curology/ui-components-web/react/Modal';
import { ModalContent } from '@curology/ui-components-web/react/Modal/ModalContent';
import { ModalFooter } from '@curology/ui-components-web/react/Modal/ModalFooter';
import { ModalHeader } from '@curology/ui-components-web/react/Modal/ModalHeader';
import { Typography } from '@curology/ui-components-web/react/Typography';
import React from 'react';

interface SignupFlowRedirectModalProps {
  isOpen: boolean;
  redirectUrl: string;
}

export const SignupFlowRedirectModal = ({
  isOpen,
  redirectUrl,
}: SignupFlowRedirectModalProps) => {
  const handleAccept = () => {
    window.location.assign(redirectUrl);
  };

  return (
    <Modal
      onClose={handleAccept}
      open={isOpen}
      title={<ModalHeader>Finish your consultation</ModalHeader>}
      type="light"
      contentStyle="card"
      width={576}
      className="!cur-z-[9999]"
    >
      <ModalContent className="cur-bg-[#ffffff] cur-p-4">
        <Typography>
          Your 30-day free trial is already in the works! We just need a few
          more details and photos of your skin to prescribe your custom
          treatment.
        </Typography>
        <Typography>
          Want to add DayPrime Rx? You&apos;ll have a chance to do so after
          uploading photos.
        </Typography>
      </ModalContent>
      <ModalFooter className="cur-z-[10000]">
        <Button
          className="cur-w-full"
          data-sentry-id="Accept signup redirect"
          onClick={handleAccept}
          size="lg"
        >
          Let&apos;s go
        </Button>
      </ModalFooter>
    </Modal>
  );
};
